import { format, isDate, parseISO, toDate } from 'date-fns'
import formatDistance from 'date-fns/formatDistance'
import differenceInYears from 'date-fns/differenceInYears'
import setHours from 'date-fns/setHours'
import setMinutes from 'date-fns/setMinutes'
import setSeconds from 'date-fns/setSeconds'
import setMilliseconds from 'date-fns/setMilliseconds'

// https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
// displayDateFormat and displayDateTimeFormat2 - Do Not Change (Its tied to backend passing format)
export const displayDateFormat = 'dd/MM/yyyy'
export const displayDateFormat2 = 'MMM dd, yyyy'
export const displayDateTimeFormat = 'MMM dd, yyyy - h:mm a'
export const displayDateTimeFormat2 = 'dd/MM/yyyy - h:mm a'
export const displayDateTimeFormat3 = 'dd/MM/yyyy - h:mm:ss.SSS a'
export const displayDateTimeFormat4 = 'dd/MM/yyyy HH:mm:ss'
export const displayTimeFormat = 'HH:mm'
export const serverTimeFormat = 'yyyy-MM-dd'

export const formatDisplayDate = date => {
  try {
    if (date) {
      if (isDate(date)) {
        if (checkValidDate(date)) {
          if (date instanceof Date) {
            return format(toDate(date), displayDateFormat)
          }
          return format(toDate(parseISO(date)), displayDateFormat)
        } else {
          return undefined
        }
      } else {
        // String Date
        return format(toDate(parseISO(date)), displayDateFormat)
      }
    }
  } catch (err) {
    //
  }
  return ''
}

export const formatDisplayDate2 = date => {
  try {
    if (date) {
      if (isDate(date)) {
        if (checkValidDate(date)) {
          if (date instanceof Date) {
            return format(toDate(date), displayDateFormat2)
          }
          return format(toDate(parseISO(date)), displayDateFormat2)
        } else {
          return undefined
        }
      } else {
        return format(toDate(parseISO(date)), displayDateFormat2)
      }
    }
  } catch (err) {
    //
  }
  return ''
}

export const formatDisplayDateTime = datetime => {
  try {
    if (datetime) {
      if (isDate(datetime)) {
        if (checkValidDate(datetime)) {
          if (datetime instanceof Date) {
            return format(toDate(datetime), displayDateTimeFormat)
          }
          return format(toDate(parseISO(datetime)), displayDateTimeFormat)
        } else {
          return undefined
        }
      } else {
        return format(toDate(parseISO(datetime)), displayDateTimeFormat)
      }
    }
  } catch (err) {
    //
  }
  return ''
}

export const formatDisplayDateTime2 = datetime => {
  try {
    if (datetime) {
      if (isDate(datetime)) {
        if (checkValidDate(datetime)) {
          return format(datetime, displayDateTimeFormat2)
        } else {
          return undefined
        }
      } else {
        return format(toDate(parseISO(datetime)), displayDateTimeFormat2)
      }
    }
  } catch (err) {
    //
  }
  return ''
}

export const formatDisplayDateTime3 = datetime => {
  try {
    if (datetime) {
      if (isDate(datetime)) {
        if (checkValidDate(datetime)) {
          return format(datetime, displayDateTimeFormat3)
        } else {
          return undefined
        }
      } else {
        return format(toDate(parseISO(datetime)), displayDateTimeFormat3)
      }
    }
  } catch (err) {
    //
  }
  return ''
}

export const formatDisplayDateTime4 = datetime => {
  try {
    if (datetime) {
      if (isDate(datetime)) {
        if (checkValidDate(datetime)) {
          return format(datetime, displayDateTimeFormat4)
        } else {
          return undefined
        }
      } else {
        return format(toDate(parseISO(datetime)), displayDateTimeFormat4)
      }
    }
  } catch (err) {
    //
  }
  return ''
}

export const formatDisplayTime = datetime => {
  try {
    if (datetime) {
      if (isDate(datetime)) {
        if (checkValidDate(datetime)) {
          return format(datetime, displayTimeFormat)
        } else {
          return undefined
        }
      } else {
        return format(toDate(parseISO(datetime)), displayTimeFormat)
      }
    }
  } catch (err) {
    //
  }
  return ''
}

export const formatDisplayTimeDistance = datetime => {
  try {
    if (datetime) {
      return formatDistance(new Date(), toDate(parseISO(datetime)))
    }
  } catch (err) {
    //
  }
  return ''
}

export const formatServerTimeFormat = datetime => {
  // This is to format datetime to server (api) recognised format (to remove timezone formatting)
  // This is to resolve date before 1981 whereby singapore changed timezone to align to hk timezone (by adding 30mins)
  try {
    if (datetime) {
      return format(toDate(parseISO(datetime)), serverTimeFormat)
    }
  } catch (err) {
    //
  }
  return ''
}

export const yearDiff = (date1, date2) => {
  try {
    const date1Eff = removeTime(date1)
    const date2Eff = removeTime(date2)
    return differenceInYears(date1Eff, date2Eff)
  } catch (err) {
    //
  }
  return undefined
}

export const removeTime = datetime => {
  let result = toDate(parseISO(datetime))
  if (!checkValidDate(result)) {
    result = new Date(datetime)
  }
  result = setHours(result, 0)
  result = setMinutes(result, 0)
  result = setSeconds(result, 0)
  result = setMilliseconds(result, 0)
  return result
}

export const setEndTime = datetime => {
  let result = toDate(parseISO(datetime))
  if (!checkValidDate(result)) {
    result = new Date(datetime)
  }
  result = setHours(result, 23)
  result = setMinutes(result, 59)
  result = setSeconds(result, 59)
  result = setMilliseconds(result, 999)
  return result
}

export const setDateTime = (date, time) => {
  let result = toDate(parseISO(date))
  if (!checkValidDate(result)) {
    result = new Date(date)
  }
  try {
    if (time !== null && typeof time !== 'undefined') {
      const times = time.split(':')
      let hours = Number(times[0])
      let mint = Number(times[1])
      result = setHours(result, hours)
      result = setMinutes(result, mint)
      result = setSeconds(result, 0)
      result = setMilliseconds(result, 0)
      return result
    }
  } catch (err) {
    throw err
  }
}

export const checkValidDate = d => {
  return d instanceof Date && !isNaN(d)
}
